// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__XR8eg","inputWrap":"CustomTip_inputWrap__3pyy7"};